import React from "react";
import { FormLayout } from "playground/cms/Form";
import Resources from "playground/cms/views/Resources";
import ImportForm from "./ImportForm";
import ListItem from "./ListItem";

//import PropTypes from 'prop-types';

export function ImportResources(props) {
    const {} = props;
    const url = "apartments/resource-bindings?order=synced_at desc";
    return (
        <Resources {...props} url={url} ListItem={ListItem}>
            <FormLayout>
                <FormLayout.Content replace={true}>
                    <FormLayout.Tab id={"resource-bindings"} label={"Import"}>
                        <ImportForm {...props} />
                    </FormLayout.Tab>
                </FormLayout.Content>
            </FormLayout>
        </Resources>
    );
}

ImportResources.propTypes = {};

ImportResources.defaultProps = {};

export default ImportResources;
